'kiwi public';

/** @module */
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import { MessageTags } from 'irc-framework';
import * as Misc from '@/helpers/Misc';

/**
 * Adds the BOUNCER IRCv3 spec to irc-framework
 */
export default function bouncerMiddleware() {
  var networks = [];
  var buffers = {};
  return function middleware(client, rawEvents, parsedEvents) {
    client.requestCap('bouncer');
    addFunctionsToClient(client);
    rawEvents.use(theMiddleware);
  };
  function theMiddleware(command, message, rawLine, client, next) {
    if (command !== 'BOUNCER') {
      next();
      return;
    }
    var params = message.params;
    if (params[0] === 'listnetworks' && ['end', 'RPL_OK'].indexOf(params[1]) > -1) {
      client.command_handler.emit('bouncer networks', networks);
      networks = [];
    } else if (params[0] === 'listnetworks') {
      var tags = MessageTags.decode(params[2]);
      networks.push({
        networkId: params[1],
        name: tags.network,
        host: tags.host,
        port: parseInt(tags.port, 10),
        tls: tags.tls === '1',
        connected: tags.state === 'connected',
        nick: tags.nick,
        currentNick: tags.currentNick,
        password: tags.password || '',
        account: tags.account || '',
        account_password: tags.account_password || ''
      });
    } else if (params[0] === 'listbuffers' && ['end', 'RPL_OK'].indexOf(params[2]) > -1) {
      var netId = params[1] || '';
      var detectedBuffers = buffers[netId] || [];
      delete buffers[netId];
      client.command_handler.emit('bouncer buffers', detectedBuffers);
      client.command_handler.emit('bouncer buffers ' + netId, detectedBuffers);
    } else if (params[0] === 'listbuffers') {
      var _netId = params[1] || '';
      var _tags = MessageTags.decode(params[2]);
      buffers[_netId] = buffers[_netId] || [];
      buffers[_netId].push({
        networkId: _netId,
        network: _tags.network,
        name: _tags.buffer,
        topic: _tags.topic,
        joined: _tags.joined === '1',
        seen: _tags.seen,
        notify: _tags.notify || 'highlight'
      });
    } else if (params[0] === 'state') {
      client.command_handler.emit('bouncer state', {
        networkId: params[1],
        network: params[2],
        state: params[3]
      });
    }

    // BOUNCER addnetwork NetID Network1 ERR_NAMEINUSE
    if (params[0] === 'addnetwork' && params[3].substr(0, 4) === 'ERR_') {
      var netName = (params[2] || '').toLowerCase();
      var eventObj = {
        error: params[3],
        reason: params[4] || ''
      };
      client.command_handler.emit('bouncer addnetwork error', eventObj);
      client.command_handler.emit('bouncer addnetwork error ' + netName, eventObj);
    } else if (params[0] === 'addnetwork' && ['end', 'RPL_OK'].indexOf(params[3]) > -1) {
      // BOUNCER addnetwork 5 Network1 RPL_OK
      var _netId2 = params[1] || '';
      var _netName = (params[2] || '').toLowerCase();
      var _eventObj = {
        networkId: _netId2,
        network: _netName
      };
      client.command_handler.emit('bouncer addnetwork ok', _eventObj);
      client.command_handler.emit('bouncer addnetwork ok ' + _netName, _eventObj);
    }
  }
}
function addFunctionsToClient(client) {
  var bnc = client.bnc = {};
  bnc.tags = function tags() {
    var token = client.network.supports('bouncer');
    return !token || typeof token !== 'string' ? {} : MessageTags.decode(token) || {};
  };
  bnc.hasNetwork = function hasNetwork() {
    var token = client.network.supports('bouncer');
    if (!token || token === true) {
      return false;
    }
    var tags = MessageTags.decode(token);
    return tags && !!tags.network;
  };
  bnc.getNetworks = function getNetworks() {
    return new _Promise(function (resolve, reject) {
      client.raw('BOUNCER listnetworks');
      client.once('bouncer networks', function (networks) {
        resolve(networks);
      });
    });
  };
  bnc.getBuffers = function getBuffers(netId) {
    return new _Promise(function (resolve, reject) {
      client.raw('BOUNCER listbuffers ' + netId);
      client.once('bouncer buffers ' + netId, function (buffers) {
        resolve(buffers);
      });
    });
  };
  bnc.closeBuffer = function closeBuffer(netId, bufferName) {
    return new _Promise(function (resolve, reject) {
      var _context;
      client.raw(_concatInstanceProperty(_context = "BOUNCER delbuffer ".concat(netId, " ")).call(_context, bufferName));
    });
  };
  bnc.bufferSeen = function bufferSeen(netId, bufferName, seenTime) {
    return new _Promise(function (resolve, reject) {
      var _context2, _context3;
      // 1 tells the bouncer to use the current time
      var seen = seenTime ? Misc.dateIso(seenTime) : '1';
      client.raw(_concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "BOUNCER changebuffer ".concat(netId, " ")).call(_context3, bufferName, " seen=")).call(_context2, seen));
    });
  };
  bnc.addNetwork = function addNetwork(netName, host, port, tls, nick, user, password) {
    var tags = {};
    tags.network = netName;
    tags.host = host;
    tags.port = port;
    tags.tls = tls ? 1 : 0;
    tags.nick = nick;
    tags.password = password;
    if (user) {
      tags.user = user;
    }
    var tagString = createTagString(tags);
    return new _Promise(function (resolve, reject) {
      client.raw('BOUNCER addnetwork ' + tagString);
      client.once('bouncer addnetwork ok ' + netName.toLowerCase(), onOk);
      client.once('bouncer addnetwork error', onError);
      function onOk(event) {
        client.off('bouncer addnetwork error', onError);
        resolve(event);
      }
      function onError(event) {
        client.off('bouncer addnetwork ok ' + netName.toLowerCase(), onOk);
        reject({
          error: event.error,
          reason: event.reason
        });
      }
    });
  };
  bnc.removeNetwork = function removeNetwork(netId, bufferName) {
    return new _Promise(function (resolve, reject) {
      client.raw("BOUNCER delnetwork ".concat(netId));
    });
  };
  bnc.saveNetwork = function saveNetwork(netId, opts) {
    var tags = {};
    if (typeof opts.network !== 'undefined') {
      tags.network = opts.network;
    }
    if (typeof opts.host !== 'undefined') {
      tags.host = opts.host;
    }
    if (typeof opts.port !== 'undefined') {
      tags.port = opts.port;
    }
    if (typeof opts.tls !== 'undefined') {
      tags.tls = opts.tls ? 1 : 0;
    }
    if (typeof opts.nick !== 'undefined') {
      tags.nick = opts.nick;
    }
    if (typeof opts.user !== 'undefined') {
      tags.user = opts.user;
    }
    if (typeof opts.password !== 'undefined') {
      tags.password = opts.password;
    }
    if (typeof opts.account_password !== 'undefined') {
      tags.account_password = opts.account_password;
    }
    if (typeof opts.account !== 'undefined') {
      tags.account = opts.account;
    }
    var tagString = createTagString(tags);
    return new _Promise(function (resolve, reject) {
      if (tagString.length === 0) {
        resolve();
      } else {
        var _context4;
        client.raw(_concatInstanceProperty(_context4 = "BOUNCER changenetwork ".concat(netId, " ")).call(_context4, tagString));
      }
    });
  };
}
function createTagString(tags) {
  var tagParts = [];
  _Object$keys(tags).forEach(function (tag) {
    var val = tags[tag];
    if (typeof val !== 'undefined') {
      val = val.toString().replace(' ', '\\s').replace(';', '\\:');
      tagParts.push(tag + '=' + val);
    } else {
      tagParts.push(tag);
    }
  });
  return tagParts.join(';');
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["BouncerMiddleware"]
window._kiwi_exports.libs.BouncerMiddleware = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
